import { Observable, observe, Scope } from 'wdc-cube'

@Observable
export class UserChangePasswordFormScope extends Scope {
    @observe() type = 'password' as 'password' | 'generate'
    @observe() showPassword = false
    @observe() showConfirmPassword = false

    @observe() newPassword?: string
    @observe() confirmNewPassword?: string
    @observe() sendToEmail = false

    onGenerate = Scope.ASYNC_ACTION
    onSave = Scope.ASYNC_ACTION
    onCancel = Scope.ASYNC_ACTION
}

export default UserChangePasswordFormScope
